import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import IndustryPage from "@/pages/IndustryPage";

export const Route = createFileRoute("/es/industrias/pharma-biotech/")({
  head: () => buildRouteHead("/es/industrias/pharma-biotech"),
  component: IndustryPage,
});

